import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getPaymentTypesData = () =>
  axiosInstance.get(`${ADMIN_API_URL}/payment-types`, {
    headers: authHeaders(),
  });

export const createPaymentTypeRequest = (formData) =>
  axiosInstance.post(`${ADMIN_API_URL}/payment-types`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updatePaymentTypeRequest = (id, formData) =>
  axiosInstance.post(`${ADMIN_API_URL}/payment-types/${id}`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const removePaymentType = (id) =>
  axiosInstance.delete(`${ADMIN_API_URL}/payment-types/${id}`, {
    headers: authHeaders(),
  });
